module.exports = __webpack_public_path__ + "img/_super_02.b7858155.jpg";